import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core';
import { dateDiff, DateInline, DateRange, FormApi, formApi, FormProps } from '../core';
import create, { UseStore } from 'zustand';

type Range = {
    startDate: Date | string,
    endDate: Date | string
}

export function customDateRangeForm(props: Partial<FormProps>): FormApi<Range> {
    const initialValues = {
        startDate: null,
        endDate: new Date()
    }
    function normalizeDateRange(st?: any, en?: any): DateRange {
        const start: Date = st || startDate.value.getState().value;
        const end: Date = en || endDate.value.getState().value;
        try {
            if (start && end) {
                const r = dateDiff(start, end, true);
                //TODO: validation messages
                r.diff = undefined;
                return r;
            }
        } catch (er) {
            console.log('normalize error', er);

        }
        return (start && end) ? { startDate: start, endDate: end } : null;
    }


    const form: FormApi = formApi({
        ...{
            values: initialValues,
            fields: {
                startDate: {
                    label: 'Start Date',
                    required: true,
                    onChange: v => {
                        const r = normalizeDateRange(v);
                        if (r) {
                            props.onChange(r)
                        }
                    },
                    onEnter: () => {
                        form.submit()
                    }
                },
                endDate: {
                    label: 'End Date',
                    required: true,
                    onChange: v => {
                        const r = normalizeDateRange(null, v);
                        if (r) {
                            props.onChange(r)
                        }
                    },
                    onEnter: () => {
                        form.submit()
                    }
                }
            },
            resetValues: () => initialValues,
            valid: v => v.startDate && v.endDate,
            onSubmit: async () => {

                if (props.onSubmit) {
                    props.onSubmit(form.values.getState().value)
                }

            }
        }
    });
    const { startDate, endDate } = form.controls;
    return form;
}


export type RangeItem = Range & {
    label: string;
}

type CustomDateRangeData = {
    open: boolean,
    selected: RangeItem
}
export type DateRangeForm = FormApi<DateRangeFormValues> & {
    setItems: (a: RangeItem[], b?: Range) => void
}
export type CustomDateRangeApi = {
    data: UseStore<CustomDateRangeData>,
    custom: FormApi<Range>,
    list: DateRangeForm
}

type CustomDateRangeApiConf = DateRangeFormProps & {
    onChange?: (item: RangeItem) => void
}
const CUSTOM_RANGE = 'Custom Range';

export function customDateRangeApi({ onChange, index }: CustomDateRangeApiConf): CustomDateRangeApi {
    const data = create<CustomDateRangeData>(() => ({
        open: false,
        selected: null
    }));

    const custom = customDateRangeForm({
        onChange: (selected: RangeItem) => {
            if (selected) {
                data.setState({ selected });
            }
        },
        onSubmit: (selected: RangeItem) => {
            if (selected) {
                data.setState({ selected, open: false });
                onChange(selected);
            }
        }
    });
    const list = dateRangeForm({
        index: index || 1,
        onEnter: (label: string) => {
            if (label === CUSTOM_RANGE) {
                data.setState({ open: true });
            }
        },
        onChange: (selected: RangeItem) => {
            if (selected?.label === CUSTOM_RANGE) {
                data.setState({ open: true });
            } else if (selected) {
                data.setState({ selected, open: false });
                onChange(selected);
            }
        }
    });

    return { data, custom, list };
}

export function CustomDateRangeDialog(api: CustomDateRangeApi) {
    const open = api.data(s => s.open);
    const { startDate, endDate } = api.custom.controls;
    const selected = api.data(s => s.selected);


    const onClose = () => {
        api.custom.reset();
    }

    return (
        open ?
            <Dialog open={open} onClose={onClose} >
                <DialogTitle>
                    Custom Date Range
                </DialogTitle>

                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        direction='row'
                        style={{ paddingBottom: 60 }}>
                        <Grid item xs={6}>
                            <DateInline {...startDate} />
                        </Grid>
                        <Grid item xs={6}>
                            <DateInline {...endDate} />
                        </Grid>
                    </Grid >
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => api.data.setState({ open: false })} variant='outlined' color='primary'>Cancel</Button>
                    <Button onClick={() => api.custom.submit()} disabled={!selected} color='primary' variant='contained'> Select </Button>
                </DialogActions>
            </Dialog >
            : <></>
    );
}

interface DateRangeFormProps {
    label?: string
    items?: RangeItem[];
    onChange?: (item: RangeItem) => void,
    onEnter?: (text: string) => void,
    style?: any;
    index?: number
}

interface DateRangeFormValues {
    range: RangeItem;
}



export function dateRangeForm(props: DateRangeFormProps): DateRangeForm {
    const { label, items, onChange, onEnter, style, index } = props;
    const list = items || [];
    const range = isNaN(index) ? null : list[index % list.length];
    const form = formApi<DateRangeFormValues>({
        values: {
            range
        },
        fields: {
            range: {
                list,
                value: range,
                placeholder: label || 'Date Range',
                listLabel: v => v.label,
                onChange: v => onChange && onChange(v),
                onEnter: v => onEnter && onEnter(v),
                style: { ...{ width: '100%' }, ...style }
            }
        }
    });
    function setItems(a: RangeItem[], b?: Range) {
        const list = a || [];
        const c = form.controls.range;
        c.list.setState({ value: list });
     
        if (b) {
            const value = list.filter(v => v.startDate === b.startDate && v.endDate === b.endDate)[0];
            if (value) {
                c.value.setState({ value });
            }
        }
    }
    return { ...form, setItems };
}



